<template>
  <div
    class="input-container input-field"
    :class="{
      'input-field--light': light,
      'input-field--appended-icon': !!icon
    }"
  >
    <input
      type="text"
      v-bind="$attrs"
      :id="id"
      :disabled="disabled"
      :name="name"
      :value="modelValue"
      :placeholder="placeholder"
      class="datepicker"
      ref="input"
      @change="$emit('update:modelValue', $event.target.value)"
      readonly
      :style="{ width }"
    />

    <i
      class="mdi pointer"
      :class="icon"
      @click.prevent="iconCallback"
      :title="iconTitle"
      v-if="iconCallback"
    ></i>
    <label ref="label" :for="id">{{ label }}</label>
  </div>
</template>
<script>
import FormSetup from '@common/Mixins/FormSetup';
export default {
  inheritAttrs: false,
  mixins: [FormSetup],
  props: {
    modelValue: {
      type: String
    },
    placeholder: {
      type: String
    },
    disabled: {
      type: Boolean
    },
    type: {
      type: String,
      default: 'text'
    },
    name: {
      type: String
    },
    id: {
      type: String
    },
    icon: {
      type: String
    },
    iconTitle: {
      type: String
    },
    iconCallback: {
      type: Function
    },
    width: {
      type: String,
      default: '100%'
    },
    label: {
      type: String
    },
    light: {
      type: Boolean
    }
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {},
  computed: {}
};
</script>

<style lang="scss" scoped>
@import '@sass/_variables.scss';

.input-field {
  &.rounded {
    input {
      border: 0 !important;
      box-shadow: none !important;
      background-color: #fff !important;
      box-shadow: 0 20px 25px 0 rgba(73, 73, 73, 0.1) !important;
      border-radius: 15px;
      height: auto;
      padding: 20px !important;
      line-height: normal;
    }
    label {
      margin-left: 20px;
      color: black !important;
      margin-top: 7px;
      &.active {
        margin-top: 0px;
        transform: translateY(2px) scale(0.8) !important;
      }
    }
    i.mdi {
      right: 15px;
      top: 11px;
      font-size: 25px;
    }
  }
}

.input-field--light input {
  color: #fff;
}

.input-field label {
  pointer-events: none;
}
</style>
